export default "__VITE_ASSET__D9LpJf8q__"